import { b as buttonTypes } from './button-types-39a4787b.js';

// DO NOT MANUALLY EDIT THIS FILE, this file is auto-generated.
// To add new icons place svg file in /src/assets/icons
// and run 'npm run generate-svg-sprites'
const icons$1 = [
    'account',
    'add-document',
    'add',
    'alert',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-up',
    'attachment',
    'bookmark-filled',
    'bookmark',
    'calculator',
    'calendar-filled',
    'calendar',
    'camera',
    'card',
    'check',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'close',
    'documents',
    'download',
    'edit',
    'error',
    'eye-filled',
    'eye-off',
    'eye',
    'facebook',
    'folder',
    'graph',
    'hang-up',
    'heart-filled',
    'heart',
    'help',
    'history',
    'instagram',
    'linkedin',
    'location-filled',
    'location',
    'lock-unlocked',
    'lock',
    'mail',
    'menu',
    'messages',
    'microphone-off',
    'microphone',
    'money',
    'nav-accounts-active',
    'nav-accounts-green-filled',
    'nav-accounts',
    'nav-home-active',
    'nav-home-green-filled',
    'nav-home',
    'nav-messages-active',
    'nav-messages-green-filled',
    'nav-messages',
    'nav-page-green-filled',
    'nav-page',
    'nav-taxes-active',
    'nav-taxes-green-filled',
    'nav-taxes',
    'online-medium',
    'online-small',
    'overflow',
    'pause',
    'phone',
    'play',
    'print',
    'refresh',
    'screenshare-stop',
    'screenshare',
    'search',
    'settings',
    'star-filled',
    'star',
    'subtract',
    'time',
    'transfer',
    'trash',
    'twitter',
    'upload',
    'video-off',
    'video',
    'youtube',
];
// DO NOT MANUALLY EDIT THIS FILE, this file is auto-generated.
// To add new icons place svg file in /src/assets/icons
// and run 'npm run generate-svg-sprites'

// DO NOT MANUALLY EDIT THIS FILE, this file is auto-generated.
// To add new icons place svg file in /src/assets/icons
// and run 'npm run generate-svg-sprites'
const icons = [
    'accounting-coach',
    'accounting-software',
    'accuracy',
    'added-dependent',
    'adopted',
    'advance',
    'advisor-match',
    'any-device',
    'audit-assistance',
    'better-together',
    'bookkeeping-team-member',
    'business-insurance',
    'business-tax',
    'care',
    'changed-jobs',
    'charitable-Donors',
    'chat',
    'child',
    'childcare',
    'claim',
    'complicated',
    'connect-your-aacounts',
    'contractors',
    'contributed-hsa',
    'creativity',
    'curious',
    'customer-centric',
    'determined',
    'doc-drop-off',
    'docu-dollar-brand',
    'e-sign',
    'earned-income',
    'easy-payroll',
    'emerald-card',
    'employee',
    'enter-manually',
    'expat',
    'experienced-advisors',
    'file-however',
    'first-year',
    'flexible-options',
    'foreign-income',
    'freelance',
    'full-time-resident',
    'guarantee',
    'hablas-espanol',
    'handwashing',
    'help-faq',
    'homeowner',
    'household-changes',
    'how-we-got-this',
    'hrb-insights',
    'hrb-office',
    'hsa-contributors',
    'i-have-kids',
    'i-have-other-dependents',
    'i-made-donations',
    'im-not-sure',
    'individualized-care',
    'interest-income',
    'investment',
    'invoicing-tools',
    'large-expenses',
    'letter',
    'make-appointment',
    'manage-in-app',
    'marital-status',
    'married',
    'mask',
    'max-refund',
    'medical-expense',
    'mobile-receipt-upload',
    'non-resident',
    'not-right-now',
    'office-or-virtual',
    'office',
    'on-demand-tech-support',
    'one-to-one',
    'parents',
    'part-time-resident',
    'passionate',
    'payment-solutions',
    'peace-of-mind',
    'phone-call',
    'phone-or-online',
    'piggy-bank-brand',
    'powerful-tools',
    'prep-and-file',
    'print-sign-send',
    'product',
    'protective-glass',
    'regular-check-ins',
    'rental-property',
    'save-close',
    'savings',
    'scan',
    'screen-share',
    'second-look',
    'security',
    'self-employed',
    'single',
    'small-business',
    'social-distancing',
    'something-else',
    'ssn-income',
    'step-by-step-guidance',
    'straightforward',
    'student',
    'tax-pro',
    'taxes',
    'thumbs-down',
    'thumbs-up',
    'tips-advice',
    'travel-expenses',
    'unemployment',
    'unlimited-help',
    'upfront-pricing',
    'video-call',
    'w2-picture',
    'ways-to-file',
    'wipe-surfaces',
    'year-end-filing-help',
    'year-round-support',
];
// DO NOT MANUALLY EDIT THIS FILE, this file is auto-generated.
// To add new icons place svg file in /src/assets/icons
// and run 'npm run generate-svg-sprites'

const styleTypeOptions = [
    'jumbo',
    'large',
    'medium',
    'small',
    'small-reg',
    'little',
    'body-copy',
    'body-copy-strong',
    'body-copy-on-green',
    'body-copy-small',
    'body-copy-support',
    'metadata',
    'cta',
    'cta-small',
    'nav',
    'nav-reg',
    'cta-qualifier',
    'card',
    'headline-one',
    'headline-two',
    'headline-three',
    'headline-four',
    'headline-five',
];
const navLinkStyleTypeOptions = [
    'body-copy',
    'large',
    'little',
    'medium',
    'small',
];

const getIsValidIcon = (icon) => icons$1.concat(icons).includes(icon);
const getIsValidButtonType = (type) => Object.values(buttonTypes).includes(type);
const getIsValidNavLinkStyleType = (type) => Object.values(navLinkStyleTypeOptions).includes(type);
const getIsValidStyleType = (type) => Object.values(styleTypeOptions).includes(type);

export { getIsValidIcon as a, getIsValidNavLinkStyleType as b, getIsValidStyleType as c, getIsValidButtonType as g };

